import { View, StyleSheet, Image, Animated } from 'react-native';
import { theme, Text } from '@socrait/react';

import { usePhaseAnimation } from '~/providers/PhaseAnimationProvider';

import splashImageUrl from '~/assets/images/splash_image.png';

const HEADLINES = [
  { prefix: 'Your ', bold: 'Voice.' },
  { prefix: 'Your ', bold: 'Data.' },
  { prefix: 'Your ', bold: 'Peace of Mind.' },
] as const;

export function SplashPanel() {
  const { phase, fadeAnim } = usePhaseAnimation();

  return (
    <View style={styles.container}>
      <Image source={{ uri: splashImageUrl }} style={styles.splashImage} resizeMode="contain" />
      <Animated.View style={[styles.headlineWrapper, { opacity: fadeAnim }]}>
        <Text style={styles.headline}>
          {HEADLINES[phase]!.prefix}
          <Text style={styles.headlineBold}>{HEADLINES[phase]!.bold}</Text>
        </Text>
      </Animated.View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing.xlarge,
  },
  splashImage: {
    width: 280,
    aspectRatio: 560 / 284,
  },
  headlineWrapper: {
    alignItems: 'center',
  },
  headline: {
    fontSize: 32,
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeights.bold,
    color: theme.colors.navy,
    textAlign: 'center',
  },
  headlineBold: {
    fontSize: 32,
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeights.bold,
    color: theme.colors.primaryPurple,
  },
});
